module.exports = __webpack_public_path__ + "img/cosmetic.36a92124.jpg";